// extracted by mini-css-extract-plugin
module.exports = {"textfield_input_root":"SwitchTextField_textfield_input_root__1b_Z9","textfield_input_notchedOutline":"SwitchTextField_textfield_input_notchedOutline__3ZCt1"};